export type ParsedMessage = {
  ref: string | null;
  text: string;
};

const decodeXmlEntities = (raw: string): string =>
  raw
    .replace(/&quot;/g, '"')
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&amp;/g, "&");

const parseXmlAttributes = (s: string): Record<string, string> => {
  const attrs: Record<string, string> = {};
  let i = 0;
  while (i < s.length) {
    while (i < s.length && /\s/.test(s[i])) {
      i += 1;
    }
    if (i >= s.length) {
      break;
    }
    const keyMatch = /^(\w+)=/.exec(s.slice(i));
    if (!keyMatch) {
      break;
    }
    const key = keyMatch[1];
    i += keyMatch[0].length;
    if (s[i] !== '"') {
      break;
    }
    i += 1;
    const end = s.indexOf('"', i);
    if (end === -1) {
      break;
    }
    attrs[key] = decodeXmlEntities(s.slice(i, end));
    i = end + 1;
  }
  return attrs;
};

const LEADING_REF_PATTERN = /^<ref\s+([\s\S]*?)\/>\s*\n?([\s\S]*)$/;

export const parseMessageReference = (content: string): ParsedMessage => {
  const match = content.match(LEADING_REF_PATTERN);
  if (!match) {
    return { ref: null, text: content };
  }
  const attrs = parseXmlAttributes(match[1]);
  return { ref: attrs.label ?? null, text: match[2] };
};
